<template>
    <!-- src/app/appComponents/workbench/attributePanel/components/AttributePanel.vue -->
    <styled-select-new
      class="advertiser-select-new__text_colors"
      :value="value"
      @input="emitInput"
      :options="options"
      :disabled="disabled"
      :searchOptions="searchOptions"
      label="Name"
      ref="select"
    />
</template>

<script>
import StyledSelectNew from './StyledSelectNew'
import { searchAdvertisers } from '@/api'
import { sortBy } from 'lodash'

export default {
  components: {
    StyledSelectNew
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: []
    }
  },
  methods: {
    searchOptions (search, loading) {
      if (search.length >= 2) {
        loading(true)
        searchAdvertisers(search)
        .then(resp => {
          let sortedResults = sortBy(resp.data, obj => obj.Name)
          this.options = sortedResults
          loading(false)
        }).catch(resp => {
          this.options = []
          loading(false)
        })
      } else {
        this.options = []
      }
    },

    emitInput (val) {
      this.$emit('input', val)
    }
  }
}

</script>

<style lang="scss">
  .advertiser-select-new__text_colors {

    .v-select .selected-tag {
      color: white !important;
    }
    .v-select.single .selected-tag {
      border-bottom: none !important;
    }
    .vue-select-vm .dropdown-toggle {
      border-bottom: none !important;
    }
    input.form-control {
      color: white !important;
      padding: 4px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// AdvertiserSelectNew.vue?0c5ed318